import {
  PortalManagementFormValuesDealer,
  PortalManagementFormValuesLender,
  PortalConfigDealer,
  PortalConfigLender,
} from '../types';

export const getConfigToSaveDealer = (formData: PortalManagementFormValuesDealer): PortalConfigDealer => {
  return {
    multiLocationManagement: formData.multiLocationManagement,
    enhancedStagesFlow: formData.enhancedStagesFlow,
    messagingModule: formData.messagingModule,
  };
};

export const getConfigToSaveLender = (formData: PortalManagementFormValuesLender): PortalConfigLender => {
  return {
    allowSyndication: formData.allowSyndication,
    allowLMS: formData.allowLMS,
    multiLocationManagement: formData.multiLocationManagement,
    enhancedStagesFlow: formData.enhancedStagesFlow,
    subsidyCalculator: formData.subsidyCalculator,
    messagingModule: formData.messagingModule,
    tieredDealers: formData.tieredDealers,
  };
};
